export default "__VITE_ASSET__Drpi3Tif__"